import React from "react";
import PageTitle from "../../../widgets/PageTitle";
import { Box } from "@mui/material";
import TemplatePreview from "../../../widgets/TemplatePreview";

const ShowTemplateView = ({ data }) => {
  return (
    <Box px={3}>
      <PageTitle>Template Message</PageTitle>
      <Box mt={1}>
        {data.template && (
          <TemplatePreview
            template={data.template}
            previewUrl={data.header?.mediaUrl ?? ""}
            fileName={data.header?.filename ?? ""}
          />
        )}
      </Box>
    </Box>
  );
};

export default ShowTemplateView;
